// Central Privacy Guard log client. Sends settings, counts and custom field NAMES — never field
// values or question text. Fire-and-forget: failures are silent.
const API = process.env.REACT_APP_BACKEND_URL;
const DEVICE_KEY = 'pg_device_id';
const SNAPSHOT_KEY = 'pg_last_snapshot_day';
const SETTINGS_KEY = 'privacy_guard_settings';

let queue = [];
let timer = null;

function deviceId() {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`);
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}

function deviceInfo() {
  const ua = navigator.userAgent || '';
  const device_type = /iPad|Tablet/i.test(ua) ? 'tablet' : /Mobi|Android|iPhone/i.test(ua) ? 'mobile' : 'desktop';
  const browser = /SamsungBrowser/i.test(ua) ? 'samsung' : /Edg\//i.test(ua) ? 'edge' : /OPR\//i.test(ua) ? 'opera'
    : /Firefox\//i.test(ua) ? 'firefox' : /Chrome\//i.test(ua) ? 'chrome' : /Safari\//i.test(ua) ? 'safari' : 'other';
  return { device_id: deviceId(), device_type, browser, app_version: 'web-1' };
}

function sessionToken() {
  return localStorage.getItem('health_portal_session');
}

async function flush() {
  timer = null;
  const token = sessionToken();
  if (!token || !queue.length) { queue = []; return; }
  const events = queue.splice(0, 50);
  if (queue.length) timer = setTimeout(flush, 500);
  try {
    await fetch(`${API}/api/privacy-guard/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_token: token, events, device: deviceInfo() }),
      keepalive: true,
    });
  } catch (e) { /* logging must never affect the user */ }
}

export function logPrivacyEvent(type, details = {}) {
  queue.push({ type, details, client_ts: new Date().toISOString() });
  if (!timer) timer = setTimeout(flush, 1500);
}

// Once per day per device: full settings snapshot (also detects lost/reset settings server-side).
export function maybeDailySnapshot() {
  const today = new Date().toISOString().slice(0, 10);
  if (localStorage.getItem(SNAPSHOT_KEY) === today || !sessionToken()) return;
  localStorage.setItem(SNAPSHOT_KEY, today);
  let s = null;
  try { s = JSON.parse(localStorage.getItem(SETTINGS_KEY)); } catch (e) { s = null; }
  const patterns = s?.patterns || [];
  logPrivacyEvent('daily_snapshot', {
    guard_on: s ? s.enabled !== false : true,
    review_gate_on: localStorage.getItem('redaction_review_gate') !== 'off',
    region: s?.region || 'US',
    patterns_active: s ? patterns.filter(p => p.enabled).length : null,
    patterns_total: s ? patterns.length : null,
    filled_count: (s?.customFields || []).filter(f => (f.value || '').trim()).length,
    settings_present: !!s,
  });
}

export function fieldsSummary(customFields) {
  const filled = customFields.filter(f => (f.value || '').trim());
  return {
    filled_count: filled.length,
    filled_types: filled.filter(f => !f.isCustom).map(f => f.id),
    custom_count: filled.filter(f => f.isCustom).length,
    custom_labels: customFields.filter(f => f.isCustom).map(f => (f.label || '').slice(0, 60)),
  };
}
